
'use strict';

import $ from 'jquery';
import OfficesView from './OfficesView';

export function createOffices() {
  let $offices = $('.js-offices');
  if ($offices.length) {
    new OfficesView({
      el: '.js-offices'
    });
  }
}



// WEBPACK FOOTER //
// ./assets/components/Offices/Offices.js